import React from 'react'
import { connect } from 'react-redux'

import DestinationActions from '../../Redux/DestinationRedux'

class FormDelete extends React.Component {

  _delete = (event) => {
    if (event) event.preventDefault()
    this.props.deleteDestination(this.props.data.id)
    this.props.closeModal()
  }

  render() {
    const { data, closeModal } = this.props

    // const Delete = () => {
    //   return <div className="alert alert-info">Deleting ...</div>
    // }

    // const Success = () => {
    //   setTimeout(() => this.props.closeModal(), 10)
    //   return <div className="alert alert-success">Deleted successfuly!</div>
    // }

    // const Error = () => {
    //   return <div className="alert alert-danger">{ this.props.error }</div>
    // }

    return (
      <div className="section" style={{ width: '40vw' }}>
        <div className="title-block">
          <h4 className="title mr-auto">Delete Destination ?</h4>
        </div>
        {/* {this.props.processing && <Delete/>}
        {this.props.success && <Success/>}
        {this.props.error && <Error/>} */}
        <form onSubmit={(e) => this._delete(e)} className="section">
          <div className="text-center">
            <h5 className="title">{ data.name }</h5>
          </div>
          <div className="d-flex justify-content-center row">
            <img className="img img-responsive m-2" src={data.image_url ? data.image_url.narrow : ''} alt="" style={{height: '75px'}}/>
            <img className="img img-responsive m-2" src={data.image_url ? data.image_url.wide : ''} alt="" style={{height: '75px'}}/>
            <img className="img img-responsive m-2" src={data.image_url ? data.image_url.wide_mobile : ''} alt="" style={{height: '75px'}}/>
          </div>
          <div className="d-flex justify-content-center">
            <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => closeModal()}>Close</button>
            <button type="submit" className="btn btn-lg btn-danger">Delete</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  processing: state.destination.processing,
  success: state.destination.success,
  error: state.destination.err
})

const dispatchToProps = (dispatch) => ({
  deleteDestination: (id) => dispatch(DestinationActions.destinationDeleteRequest({id}))
})

export default connect(stateToProps, dispatchToProps)(FormDelete)



// WEBPACK FOOTER //
// ./src/Containers/Destination/FormDelete.js